import self from "../img/self.png";
import mock1 from "../img/mock1.png";
import mock2 from "../img/mock2.png";
import mock3 from "../img/mock3.png";
import mock4 from "../img/mock4.png";
import mock5 from "../img/mock5.png";
import logo from "../img/logo.png";

/* Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of
how to make this template work best for you! */

export let colors = ["rgb(0,255,164)", "rgb(166,104,255)"];
/*
I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout
the site.
 */

/*
So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'. I'll try to explain anything
that might not be obvious right off the bat :) I recommend looking at the template example live using "npm start" to get an idea
of what each of the values mean.
 */

export const info = {
  firstName: "Israk",
  lastName: "Kayum",
  initials: logo, // the example uses first and last, but feel free to use three or more if you like.
  position: "a MERN Developer",
  selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],
  miniBio: [
    // these are just some "tidbits" about yourself. You can look at mine https://paytonjewell.github.io/#/ for an example if you'd like
    {
      emoji: "⛽",
      text: "fueled by hangout",
    },
    {
      emoji: "🌎",
      text: "based in the BD",
    },
    {
      emoji: "😍",
      text: "enthusiastic at programming",
    },
    {
      emoji: "📧",
      text: "israk.kayum@gmail.com",
    },
  ],
  socials: [
    {
      link: "https://codeforces.com/profile/israkkayum",
      icon: "fa fa-file",
      label: "file",
    },
    {
      link: "https://github.com/israkkayum",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://www.linkedin.com/in/israkkayum/",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "https://www.youtube.com/channel/UCeqKLDdFZrt5vvtHKFTbIVg",
      icon: "fa fa-youtube",
      label: "youtube",
    },
    {
      link: "https://learnwithisrak.com",
      icon: "fa fa-rss",
      label: "blog",
    },
    // Feel free to remove any of these that you don't have. I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
    // Just change the links so that they lead to your social profiles.
  ],
  bio: "Hello! I'm Israk. As the founder of LearnWithIsrak, I am passionate about creating and sharing blogs on various topics related to computer science and engineering, such as database structures, object-oriented programming, and web development. I am also pursuing my BSc in Computer Science and Engineering at Bangladesh Open University, where I have completed multiple projects and assignments using Java, MERN, C++ and C# languages, as well as MySQL and Microsoft tools. I am eager to learn more and apply my skills to real-world problems and solutions. My goal is to become a successful software engineer and educator and to inspire others to follow their dreams in the field of technology.",
  skills: {
    proficientWith: [
      "javascript",
      "react",
      "git",
      "github",
      "bootstrap",
      "tailwind",
      "mui",
      "html5",
      "css",
      "mongodb",
      "c++",
      "c#",
      "java",
      "mysql",
    ],
    exposedTo: ["nodejs"],
  },
  hobbies: [
    {
      label: "null",
      emoji: "😬",
    },
    // Same as above, change the emojis to match / relate to your hobbies or interests.
    // You can also remove the emojis if you'd like, I just think they look cute :P
  ],
  portfolio: [
    // This is where your portfolio projects will be detailed
    {
      title: "FatiSheba",
      live: "#",
      sourceClient: "https://github.com/israkkayum/fatiksheba-client",
      sourceServer: "https://github.com/israkkayum/fatiksheba-server",
      quickDoc: "The project details will coming soon",
      image: mock1,
    },
    {
      title: "Bibaho Mubarok",
      live: "https://biodata-b117d.web.app/",
      sourceClient: "https://github.com/israkkayum/biodata-client",
      sourceServer: "https://github.com/israkkayum/biodata-server",
      quickDoc: "The project details will coming soon",
      image: mock2,
    },
  ],
};
